import React from "react";
import { useLoading } from "../../../context/loadingContext";
import GetProductTypes from "../../../functions/reference/getProductType";
import { Table, Tag } from "antd";
import dayjs from "dayjs";

const ProductTypeList = () => {
  const [data, setData] = React.useState([]);
  const { showLoading, hideLoading } = useLoading();
  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    showLoading();

    const response = await GetProductTypes();
    if (response) setData(response);
    hideLoading();
    //set data
  };
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 50,
      fixed: "left",
    },
    {
      title: "Нэр",
      dataIndex: "name",
      key: "name",
      width: 150,
    },
    {
      title: "Гүйлгээний төрөл",
      dataIndex: "paymentType",
      key: "paymentType",
      width: 150,
      render: (e) =>
        e === "PAYMENT" ? (
          <Tag color="geekblue">{"PAYMENT"}</Tag>
        ) : (
          <Tag color="cyan">{"PURCHASE"}</Tag>
        ),
    },
    {
      title: "Үүсгэсэн огноо",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: (e) => dayjs(e).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Зассан огноо",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 100,
      render: (e) => dayjs(e).format("YYYY-MM-DD HH:mm:ss"),
    },
  ];
  return (
    <div>
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey="id"
      />
    </div>
  );
};

export default ProductTypeList;
